import { createReducer } from "@reduxjs/toolkit";
import { Timer } from "../../entities/timer";
import { arrayToMap } from "../../helpers";
import {
  clearCurrentTimer,
  deleteTimerSuccess,
  getCurrentTimerSuccess,
  getTimerByIdSuccess,
  getTimersSearchMetadataSuccess,
  getTimersSuccess,
  setSelectedTimerID,
  setStagedTimer,
  setTimerFilters,
  setTimerFormOpen,
  setTimerLoading,
  setTimerSearchOpen,
  updateStagedTimer,
} from "./timerActions";
import { TimerState } from "./timerState";

function initState(): TimerState {
  return {
    timers: {},
    searchOpen: false,
    searchMetadata: undefined,
    loading: false,
    stagedTimer: undefined,
    selectedTimerID: undefined,
    timerFormOpen: false,
  };
}

export const timerReducer = createReducer(initState(), (builder) => {
  builder.addCase(setTimerFormOpen, (state, action) => {
    state.timerFormOpen = action.payload.open;
    return state;
  });
  builder.addCase(setTimerLoading, (state, action) => {
    state.loading = action.payload.loading;
    return state;
  });
  builder.addCase(setStagedTimer, (state, action) => {
    state.stagedTimer = action.payload.stagedTimer;
    return state;
  });
  builder.addCase(setTimerFilters, (state, action) => {
    state.filters = action.payload.filters;
    return state;
  });
  builder.addCase(setTimerSearchOpen, (state, action) => {
    state.searchOpen = action.payload.searchOpen;
    return state;
  });
  builder.addCase(updateStagedTimer, (state, action) => {
    if (!state.stagedTimer) return state;
    state.stagedTimer = {
      ...state.stagedTimer,
      ...action.payload.stagedTimer,
    };
    return state;
  });
  builder.addCase(setSelectedTimerID, (state, action) => {
    state.selectedTimerID = action.payload.timerID;
    return state;
  });
  builder.addCase(getTimersSuccess, (state, action) => {
    const timers = action.payload.timers;
    state.timers = arrayToMap<Timer>(timers);
    return state;
  });
  builder.addCase(getTimersSearchMetadataSuccess, (state, action) => {
    state.searchMetadata = action.payload.timersSearchMetadata;
    return state;
  });
  builder.addCase(deleteTimerSuccess, (state, action) => {
    const timerID = action.payload.timerID;
    if (state.timers[timerID]) {
      delete state.timers[timerID];
    }
    return state;
  });
  builder.addCase(getTimerByIdSuccess, (state, action) => {
    const timer = action.payload.timer;
    if (timer) {
      const timers = { ...state.timers };
      timers[timer.id] = timer;
      state.timers = timers;
    }
    return state;
  });
  builder.addCase(getCurrentTimerSuccess, (state, action) => {
    const timer = action.payload.timer;
    state.currentTimer = timer;
    return state;
  });
  builder.addCase(clearCurrentTimer, (state) => {
    state.currentTimer = undefined;
    return state;
  });
});
